storefrontApp.controller('LoyaltyLandingController', ['$scope', '$sce', '$interval', 'loyaltyService', function($scope, $sce, $interval, loyaltyService) {
    'use strict';

    // Initialize empty arrays/objects
    $scope.faqs = [];
    $scope.faqContact = {};
    $scope.loyaltyContent = {};

    // Testimonial rotation
    $scope.currentTestimonial = 0;
    
    // Function to set current testimonial
    $scope.setTestimonial = function(index) {
        $scope.currentTestimonial = index;
    };

    // Auto rotate testimonials
    var testimonialInterval = $interval(function() {
        $scope.currentTestimonial = ($scope.currentTestimonial + 1) % 3;
    }, 5000);

    // Clean up interval when controller is destroyed
    $scope.$on('$destroy', function() {
        if (testimonialInterval) {
            $interval.cancel(testimonialInterval);
        }
    });

    // Fetch loyalty content from API
    loyaltyService.getLoyaltyContent()
        .then(function(response) {
            $scope.loyaltyContent = response.data;

            // Set FAQs from API response
            if ($scope.loyaltyContent.faq) {
                $scope.faqs = $scope.loyaltyContent.faq.items || [];
                $scope.faqContact = $scope.loyaltyContent.faq.contact || {};
            }

            // Initialize isOpen property for each FAQ
            $scope.faqs.forEach(function(faq) {
                faq.isOpen = false;
            });
        })
        .catch(function(error) {
            // Initialize with default FAQs if API fails
            $scope.faqContact = {
                text: 'Still have questions?',
                linkText: 'Contact our support team',
                linkUrl: '/contact'
            };
        });

    // FAQ toggle with isOpen property
    $scope.toggleFaq = function(index) {
        $scope.faqs[index].isOpen = !$scope.faqs[index].isOpen;
    };

    // Trust HTML content
    $scope.trustHtml = function(html) {
        return $sce.trustAsHtml(html);
    };

    // Smooth scroll for anchor links
    $scope.scrollToSection = function(elementId) {
        var element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
}]);